import {Children, isValidElement, ReactElement, ReactNode} from 'react';

/**
 * children 으로 들어온 엘리먼트 중 type 에 해당하는 요소만 반환합니다
 */
export function getByType({
  children,
  type,
}: {
  children: ReactNode;
  type: any;
}):
  | ReactElement
  | string
  | number
  | Iterable<ReactNode>
  | React.ReactPortal
  | undefined {
  const childrenArray = Children.toArray(children);
  // @ts-ignore
  return childrenArray.find(
    child => isValidElement(child) && child.type === type
  );
}
